<template>
  <div>
    <h3>Lista wybranych materiałów</h3>
    <ul class="goods-list">


      <table class="retailMarginTable" v-bind:class="{ '.thin': '' }">
        <thead>
        <tr>
          <th class="boxed">Lp</th>
          <th class="boxed">Produkt</th>
          <th class="boxed" v-if="type==='sp'">Marża</th>
          <th class="boxed" v-if="type==='sp'">Cena jednostkowa</th>
          <th class="boxed">Ilość</th>
        </tr>

        </thead>
        <tbody>
        <tr v-for="(material, index) in materials" :key="'sm'+index">
          <td>{{ index + 1 }}
            <b-button
                variant="white"
                class="delete"
                title="usuń materiał"
                @click="$emit('remove', material)"
            >
              <i class="fas fa-times"></i>
            </b-button></td>
          <td>{{ material.name }}</td>
          <td v-if="type==='sp'">

            <b-input-group
                :prepend="'%'">
              <b-form-input
                  v-model="material.margin"
                  type="number"
                  min="0"
                  max="100"
                  placeholder="marża"

              ></b-form-input>
            </b-input-group>
          </td>
          <td v-if="type==='sp'">
            <div class="counter">



                <b-input-group
                    :prepend="getMainBaseCurrency">
                <b-form-input readonly
                    :value="calculateMargin(material)"
                    placeholder="Cena"

                ></b-form-input>
                </b-input-group>


            </div>
          </td>
          <td>
            <div class="regulator">
              <b-button variant="none" @click="$emit('increment', material)">
                <i class="fas fa-plus-square"></i>
              </b-button>
              <b-form-input
                  :value="material.quantity"
                  :formatter="formatNumber"
                  @blur="rounding($event, material)"
                  type="text"
              ></b-form-input>
              <b-button variant="none" @click="$emit('decrement', material)">
                <i class="fas fa-minus-square"></i>
              </b-button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>


    </ul>
  </div>
</template>

<script>
import { numberFormat } from "@/services/helpers";
import {mapGetters} from "vuex";


export default {
  props: {
    materials: Array,
    type: String,
  },
  data() {
    return {
      priceMargin: null,
    };
  },

  computed: {
    ...mapGetters("company", ["getMainBaseCurrency"]),

  },
  methods: {
    calculateMargin(material) {

      if (material.margin > 100) {
        material.margin =100
      } else if (material.margin < 0 ) {
        material.margin = 0
      }
      material.priceMargin =  material.price + ( material.price * material.margin / 100)
      return material.priceMargin
    },

    formatNumber: numberFormat,
    rounding: function($event, material) {
      let value = parseInt($event.target.value, 10) - material.quantity;
      if (value === 0) {
        let tmp = parseInt($event.target.value, 10);
        material.quantity -= 1;
        this.$nextTick(function() {
          material.quantity = tmp;
        });
      } else {
        this.$emit("setInput", material, value);
      }
    },

  }
};
</script>
